import { ArrowRight } from "lucide-react";
import Flag from "react-world-flags";
import { ROUTES } from "@/lib/routes";

const greetings = ["Hello", "नमस्ते", "Hallo", "Ciao", "Bonjour", "こんにちは"];

const marketplaces = [
  { code: "US", label: "United States of America" },
  { code: "GB", label: "United Kingdom" },
  { code: "IN", label: "India" },
  { code: "DE", label: "Germany" },
  { code: "IT", label: "Italy" },
  { code: "ES", label: "Spain" },
  { code: "FR", label: "France" },
  { code: "JP", label: "Japan" },
] as const;

const headingFont = { fontFamily: "var(--font-display), 'Hanken Grotesk', sans-serif" };

function MarketplaceBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 h-[min(421px,72vw)] w-[min(847px,92vw)] -translate-x-1/2 -translate-y-1/2 bg-contain bg-center bg-no-repeat"
      data-testid="marketplace-object-background"
      style={{ backgroundImage: "url('/Object.svg')" }}
    />
  );
}

export default function MarketplaceOptimizationSection() {
  return (
    <section className="relative isolate flex min-h-[420px] w-full items-center justify-center overflow-hidden bg-white px-4 py-20 sm:px-8 md:min-h-[498px] lg:px-[120px]">
      <MarketplaceBackdrop />

      <div className="relative z-10 flex w-full max-w-[1200px] flex-col items-center gap-10 text-center">
        <div className="flex w-full max-w-[780px] flex-col items-center gap-3">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {greetings.map((greeting) => (
              <span
                key={greeting}
                className="text-[26px] font-semibold leading-[38px] text-[#1B1C30] sm:text-[32px] sm:leading-[46px]"
                style={headingFont}
              >
                {greeting}
              </span>
            ))}
          </div>

          <h2 className="text-[19px] font-semibold leading-[27px] text-[#1B1C30] sm:text-[22px] sm:leading-[29px]" style={headingFont}>
            Optimize Listings for Every Amazon Marketplace
          </h2>
        </div>

        <div className="flex max-w-full flex-wrap items-center justify-center gap-4 sm:gap-6">
          {marketplaces.map((marketplace) => (
            <span
              key={marketplace.code}
              className="block h-[45px] w-[60px] overflow-hidden rounded-xl border border-[#E0EAF4] bg-white shadow-[0_8px_22px_rgba(20,100,255,0.08)]"
              aria-label={marketplace.label}
              role="img"
            >
              <Flag code={marketplace.code} className="h-full w-full object-cover" />
            </span>
          ))}
        </div>

        <a
          href={ROUTES.homePricing}
          className="inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-[#1464FF] px-6 text-[15px] font-semibold leading-5 tracking-[0.43px] text-white transition-colors hover:bg-[#0D4FD6] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1464FF]"
          style={headingFont}
        >
          Try Free
          <ArrowRight aria-hidden="true" className="h-6 w-6" strokeWidth={1.5} />
        </a>
      </div>
    </section>
  );
}
